import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ChallengeSummaryService } from './../../challenge-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SlideoutContentService } from '../../../service/slideout-content.service';
import { CnEditmodeService } from '../challenges_service/cn-editmode.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-clarify-challenge',
  templateUrl: './clarify-challenge.component.html',
  styleUrls: ['./clarify-challenge.component.scss']
})

export class ClarifyChallengeComponent implements OnInit, OnDestroy {

	private destroy$ = new Subject<void>();

	breakthrough_content:any = [];
	breakthrough_dropdown:any = [];
	edit_breakthrough:boolean = false;
	datadump_content:any = [];
	dupli_datadump_content:any = [];
	edit_datadump:boolean = false;
	question_content:any = [];
	dupli_question_content:any = [];
	question_dropdown:any = [];
	edit_question:boolean = false;
	breakthrough:any = [];
	data_dump:any = [0];
	question:any = [0];
	showBreakthrough: boolean = false;
	showDatadump: boolean = false;
	showQuestion: boolean = false;
	Btupdate:boolean = false;
	BtId:string = '';
	Ddupdate:boolean = false;
	DdId:string = '';
	Qtupdate:boolean = false;
	QtId:string = '';
	selected_breakthrough:string;
	selected_datadump:string;
	selected_question:string;
	prev_breakthrough_content: any = [];
	prev_datadump_content: any = [];
	prev_question_content: any = [];
	loading_breakthrough: boolean = false;
	loading_datadump: boolean = false;
	loading_question: boolean = false;
	DivergeConvergeVal:boolean= false;
	all_data: any = [];
	deleteDatavalue:number;
	modal:any;
	slideoutGoal:any;
	slideoutData:any;
	slideoutChallenge:any;
	slideoutDivergeContent:any;
	slideoutConvergeContent:any;
	pin_challenge: boolean = false;
	listGridView:string = 'listView';
	hideOnEditMode:boolean = true;
	EditModeIcon:boolean = false;
	editGoalView:boolean = true;
	editDataView:boolean = true;
	editthinkmode:boolean = false;
	editChallengeView:boolean = true;
	goalInput:boolean = false;
	dataInput:boolean = false;
	trackLabel:boolean = false;
	trackbtn:boolean = false;
	gridViewClass:string = '';
	currentTracker:string = '';
	PreviousTracker:string = '';
	dupli_breakthrough_content:any = [];
	backtoideate:boolean = false;
	hideDivLabel:string = 'See all diverged options';
	hideclarify:boolean = false;
	clarifyEyeIcon:boolean = false;
	personae:string = 'Select option';
	statementStarter:string = 'Select option';
	temprature:any = 0;
	openAiData:any = [];
	selectAiData:any = [];
	counter:number = 0;
	loader:boolean = false;

  	constructor(public chService: CnEditmodeService , public router: Router, public allChallenge: ChallengeSummaryService,private modalService: NgbModal,public slideContent:SlideoutContentService,public editmodeService:CnEditmodeService,public http: HttpClient) {	}

	ngOnDestroy(){
		this.destroy$.next();
		this.destroy$.complete();

		let togglemenu = document.querySelector('.trigger-mini-bar') as HTMLElement;
		if(togglemenu?.classList.contains('squeeze')){
			togglemenu.click();
			togglemenu.classList.remove('squeeze');
		}
		this.openEditmode(true,true,true,true,'block','#fff');
	}

  	async ngOnInit() {
		this.loader = true;
		let togglemenu = document.querySelector('.trigger-mini-bar') as HTMLElement;
		if(!togglemenu.classList.contains('squeeze')){
			togglemenu.click();
			togglemenu.classList.add('squeeze');
		}

		if(this.editmodeService.editmode.value){
			let page = document.getElementById('page-wrapper');
			page.style.background = '#fff';
			let footer = document.querySelector('.footer') as HTMLElement;
			footer.style.backgroundColor = '#fff';
			footer.style.border = 'none';
			this.editmodeService.editmode.next(false);
		}
		this.slideoutDivergeContent = this.slideContent.divergeConvergeContent().clarify.diverge;
		this.slideoutConvergeContent = this.slideContent.divergeConvergeContent().clarify.converge;
		this.slideoutGoal = this.slideContent.divergeConvergeContent().clarify.goal;
		this.slideoutData = this.slideContent.divergeConvergeContent().clarify.data;
		this.slideoutChallenge = this.slideContent.divergeConvergeContent().clarify.challenge;

	  	var that = this;

		let clarifyPromise = new Promise((resolve,error)=>{
			let BtFilter = {email:{eq:localStorage.getItem('email')}, processTypeId:{eq:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2"}, type:{eq:"process-stage"}, title:{eq:"vision"}};
			this.chService.api.ListFrameworks(BtFilter,10000).then(function (data) {
				if(data.items.length == 0){
					that.edit_breakthrough = false;
					that.breakthrough_content[0] = '';
					that.breakthrough[0] = '';
					that.breakthrough_dropdown[0] = '';
					that.breakthrough_content[1] = '';
					that.breakthrough_dropdown[1] = 'It would be great if...';
					that.breakthrough[1] = '';
				}else{
					that.BtId = data.items[0].id;
					that.Btupdate = true;
					that.breakthrough = JSON.parse(data.items[0].content);
					that.prev_breakthrough_content = JSON.parse(data.items[0].content);
					var breakthrough = JSON.parse(data.items[0].content);
					for(var i=0;i<breakthrough.length;i++){
						let data_str = (breakthrough[i])?.split("\n");
						that.breakthrough_dropdown[i] = data_str[0];
						that.breakthrough_content[i] = data_str[1];
						that.dupli_breakthrough_content[i] = data_str[1];
					}
					that.selected_breakthrough = that.breakthrough_dropdown[0]+that.breakthrough_content[0];
					that.edit_breakthrough = false;
					that.showBreakthrough = true;
				}
			})
			let DdFilter = {email:{eq:localStorage.getItem('email')}, processTypeId:{eq:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2"}, type:{eq:"process-stage"}, title:{eq:"data-gather"}};
			this.chService?.api.ListFrameworks(DdFilter,10000).then(function (data) {
				if(data.items.length == 0){
					that.edit_datadump = false;
					that.datadump_content[0] = '';
					that.data_dump[0] = '';
					that.datadump_content[1] = '';
					that.data_dump[1] = '';
				}else{
					that.DdId = data.items[0].id;
					that.Ddupdate = true;
					that.data_dump = JSON.parse(data.items[0].content);
					that.datadump_content = JSON.parse(data.items[0].content);
					that.dupli_datadump_content = JSON.parse(data.items[0].content);
					that.prev_datadump_content = JSON.parse(data.items[0].content);
					that.selected_datadump = that.datadump_content[0];
					that.edit_datadump = false;
					that.showDatadump = true;
				}
			})
			let QtFilter = {email:{eq:localStorage.getItem('email')}, processTypeId:{eq:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2"}, type:{eq:"process-stage"}, title:{eq:"breakthrough-question"}};
			this.chService?.api.ListFrameworks(QtFilter,10000).then(function (data) {
				if(data.items.length == 0){
					that.edit_question = false;
					that.question_content[0] = '';
					that.question_dropdown[0] = '';
					that.question[0] = '';
					that.question_content[1] = '';
					that.question_dropdown[1] = 'How might...';
					that.question[1] = '';
				}else{
					that.QtId = data.items[0].id;
					that.Qtupdate = true;
					that.question = JSON.parse(data.items[0].content);
					that.prev_question_content = JSON.parse(data.items[0].content);
					that.dupli_question_content = JSON.parse(data.items[0].content)
					var ques = JSON.parse(data.items[0].content);
					for(var i=0;i<ques.length;i++){
						let data_str = (ques[i]).split("\n");
						that.question_dropdown[i] = data_str[0];
						that.question_content[i] = data_str[1];
						that.dupli_question_content[i] = data_str[1];
					}
					that.selected_question = that.question_dropdown[0]+that.question_content[0];
					that.edit_question = false;
					that.showQuestion = true;
				}
			})
			setTimeout(() => {
				resolve([BtFilter,DdFilter,QtFilter]);
			}, 1000);
		})

		clarifyPromise.then(()=> {
			this.loader = false;
		})
	    $(document).on("click", ".popaccordian__rowhead", function(e) {
	    	e.stopPropagation();
	  		var thisPar = $(this).parents(".popaccordian__row");

	  		if( !$(thisPar).hasClass("popaccordian__row--active") ) {
	  			thisPar.find(".popaccordian__rowbody").slideDown();
	  			thisPar.siblings().find(".popaccordian__rowbody").slideUp();
	  			thisPar.addClass("popaccordian__row--active");
	  			thisPar.siblings().removeClass("popaccordian__row--active");
	  		} else {
	  			thisPar.siblings().find(".popaccordian__rowbody").slideUp();
	  		}
	    })

		if(localStorage.getItem('ideateToclarify') == 'true'){
			localStorage.setItem('ideateToclarify','false');
			that.backtoideate = true;
			await setTimeout(() => {
				that.QtStart(1);
			},1000);
		}
	}

	public BtStart(){
		this.BtId = '0';
		this.edit_breakthrough = true;
		this.breakthrough_content[0] = '';
    	this.breakthrough[0] = '';
    	this.breakthrough_dropdown[0] = '';
    	this.breakthrough_content[1] = '';
    	this.breakthrough_dropdown[1] = 'It would be great if...';
    	this.breakthrough[1] = '';
		this.BtDiverge();
	}

	public BtConverge(){
		this.cancelBt();
		this.showBreakthrough = false;
		this.edit_breakthrough = false;
	}

	public BtDiverge(trackit = 0, currentTrack =''){
		this.showBreakthrough = false;
		this.edit_breakthrough = true;
		this.cancelDd();
		this.cancelQt();
		if(trackit == 1){
			this.trackLabel = true;
			this.trackbtn = true;
			this.currentTracker = currentTrack;
			this.openEditmode(true,false,false);
			this.clarifyEyeIcon = true;
		}else{
			this.PreviousTracker = 'Goal';
			this.openEditmode(true,false,false,true);
			this.clarifyEyeIcon = false;
		}
		setTimeout(() => {
			$(document).scrollTop(0);
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length == 1) {
				allBtDelIcon[0].classList.add('card-body__minus--hide');
			}
		}, 10);

	}

	public dupli_submitBreakthrough(backto = false) {
		if(this.trackLabel){
			for(let i =1; i < this.breakthrough.length; i++){
				if(this.dupli_breakthrough_content[i] != this.breakthrough_content[i] && this.dupli_breakthrough_content[i] != undefined ){
					this.addBtLine();
					this.breakthrough_content.push(this.dupli_breakthrough_content[i]);
					this.breakthrough_content[0] =  this.dupli_breakthrough_content[i];
					this.selected_breakthrough = this.breakthrough_dropdown[i] + this.dupli_breakthrough_content[i];
				}
			}
		}else {
			this.breakthrough_content = this.dupli_breakthrough_content;
		}
		if(backto){
		this.submitBreakthrough(false,true);
		}else{
			this.submitBreakthrough(false);
		}
	}

	public async submitBreakthrough(click = true,callback=false){
		this.openEditmode(true,false,false,click);

  		var change_selected = 0;
  		for(var i=1; i<this.breakthrough_content.length;i++){
  			if(this.breakthrough_content[i] == this.breakthrough_content[0] && this.breakthrough_dropdown[i] == this.breakthrough_dropdown[0]){
  				change_selected = 1;
  			}
			if(this.breakthrough_content[i] == null || this.breakthrough_content[i] == ''){
				this.breakthrough_content.splice(i,1);
				this.breakthrough_dropdown.splice(i,1);
			}
			if(i == this.breakthrough_content.length - 1 && change_selected == 0){
  				this.breakthrough_content[0] = '';
  				this.breakthrough_dropdown[0] = '';
  			}
		}
	  	if(this.breakthrough_content.length > 1){
	  		this.loading_breakthrough = true;
	  		var that = this;
	  		var content = [];

	  		for(var i=0; i<this.breakthrough_content.length;i++){
	  			content[i] = this.breakthrough_dropdown[i].concat("\n"+this.breakthrough_content[i]);
	  		}
	  		if(!this.Btupdate){
	  		await	this.chService?.api.CreateFramework({email:localStorage.getItem('email'), title:"vision", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(content)}).then(function (data){
					that.edit_breakthrough = false;
					that.BtId = data.id;
					that.Btupdate = true;
					that.loading_breakthrough = false;
					that.breakthrough = JSON.parse(data.content);
					that.prev_breakthrough_content = JSON.parse(data.content);
					var breakthrough = JSON.parse(data.content);
					that.showBreakthrough = false;
					for(var i=0;i<breakthrough.length;i++){
						let data_str = (breakthrough[i]).split("\n");
						that.breakthrough_dropdown[i] = data_str[0];
						that.breakthrough_content[i] = data_str[1];
					}
					that.selected_breakthrough = that.breakthrough_dropdown[0]+that.breakthrough_content[0];
					setTimeout(() => {
						toastr.options = {
							closeButton: true,
							progressBar: true,
							timeOut: 2000
						};
						toastr.success('Your thought has been updated!', 'Nice!');
					}, 1000);
				})
	  		}else{
	  		await this.chService?.api.UpdateFramework({id:this.BtId,email:localStorage.getItem('email'), title:"vision", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(content)}).then(function (data){
					that.edit_breakthrough = false;
					that.loading_breakthrough = false;
					that.breakthrough = JSON.parse(data.content);
					that.prev_breakthrough_content = JSON.parse(data.content);
					that.showBreakthrough = false;
					var breakthrough = JSON.parse(data.content);
					for(var i=0;i<breakthrough.length;i++){
						let data_str = (breakthrough[i]).split("\n");
						that.breakthrough_dropdown[i] = data_str[0];
						that.breakthrough_content[i] = data_str[1];
					}
					that.selected_breakthrough = that.breakthrough_dropdown[0]+that.breakthrough_content[0];
					setTimeout(() => {
						toastr.options = {
							closeButton: true,
							progressBar: true,
							timeOut: 2000
						};
						toastr.success('Your thoughts have been updated!', 'Nice!');
					}, 1000);
				})
	  		}

  		}else{
  			if(this.BtId && this.BtId != '0'){
	  			this.delBreakthrough();
	  		}
  			this.BtId = '';
	  		this.edit_breakthrough = false;
  		}
		if(callback){
			switch(this.PreviousTracker){
				case 'Data':
					this.DdDiverge();
					break;
				case 'Challenge':
					this.QtDiverge();
					break;
				default:
					this.openEditmode(true,true,true)
			}
		}
  	}

  	public delBreakthrough(){
	  	var that = this;
		  this.dupli_breakthrough_content = [];
		  try {
		  	this.chService?.api.DeleteFramework({id:this.BtId}).then(function(){
		  		that.breakthrough_content = [];
		  		that.prev_breakthrough_content = [];
		  		that.breakthrough = [];
		  		that.Btupdate = false;
		  		that.BtId = '';
		  		that.edit_breakthrough = false;
		    	that.breakthrough_content[0] = '';
		    	that.breakthrough_dropdown[0] = '';
		    	that.breakthrough[0] = '';
		    	that.breakthrough_content[1] = '';
		    	that.breakthrough_dropdown[0] = 'It would be great if...';
		    	that.breakthrough[1] = '';
		  		setTimeout(() => {
		            toastr.options = {
		                closeButton: true,
		                progressBar: true,
		                timeOut: 2000
		            };
		            toastr.success('Your thoughts has been deleted!', 'Nice!');
		        }, 1000);
		  	})
		  } catch (err) {
		  }
	}

  	public submit_converge_breakthrough(){
		if(this.pin_challenge){
			this.pin_challenge = this.editmodeService.stickChallenge(this.pin_challenge);
		}
  		this.edit_breakthrough = false;
  		this.showBreakthrough = true;
		this.trackLabel = false;
		this.trackbtn = false;
		this.openEditmode(true,true,true,true,'block','#fff');
  	}

	public async gotonextstep(next_step_val){
		switch (next_step_val) {
			case 'data':
				this.submit_converge_breakthrough();
				if(!this.DdId && !this.edit_datadump){
					this.DdStart()
				}else{
					this.DdDiverge();
				}
				break;
			case 'challenge':
				this.submit_converge_datadump();
				if(!this.QtId && !this.edit_question){
					this.QtStart();
				}else{
					this.QtDiverge();
				}
				break;
			case 'ideate':
				this.submit_converge_question();
				localStorage.setItem('gotoideate','true');
				this.router.navigate(['/challenges/ideate']);
				break;
			default:
				break;
		}
	}

  	public addBtLine(){
		if(this.trackbtn){
			this.trackbtn = false;
		}
		setTimeout(() => {
			$('.card-body__editcol.hideblk:last-child').css('display','block');
		},50);
  		if(document.activeElement.id){
	  		if(this.breakthrough.length <= parseInt(document.activeElement.id.replace("Bt","")) + 1 ){
	  			this.breakthrough.push(this.breakthrough.length);
	  			this.breakthrough_dropdown[this.breakthrough.length - 1] = 'It would be great if...';
	  		}else{
	  			for(var i=parseInt(document.activeElement.id.replace("Bt",""))+1; i<=this.breakthrough.length-1; i++){
	  				if(this.breakthrough_content[i] == '' || this.breakthrough_content[i] == undefined){
	  					document.getElementById("Bt"+ (i)).focus();
	  					break;
	  				}
	  				if(i == this.breakthrough.length - 1 && this.breakthrough_content[i] != '' && this.breakthrough_content[i] != undefined){
	  					this.breakthrough.push(this.breakthrough.length);
	  					this.breakthrough_dropdown[this.breakthrough.length - 1] = 'It would be great if...';
	  				}
	  			}
	  		}
	  	}else{
	  		this.breakthrough.push(this.breakthrough.length);
			this.breakthrough_dropdown[this.breakthrough.length - 1] = 'It would be great if...';
	  	}

		setTimeout(() => {
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length > 1) {
				allBtDelIcon[0].classList.remove('card-body__minus--hide');
			}
		},10)
  	}

  	public subBtLine(i){
  		if(this.selected_breakthrough == this.breakthrough_dropdown[i]+this.breakthrough_content[i]){
  			this.selected_breakthrough = '';
  			this.breakthrough_dropdown[0] = '';
  			this.breakthrough_content[0] = '';
  		}
	  	this.breakthrough_content.splice(i,1);
		this.dupli_breakthrough_content.splice(i,1);
	  	this.breakthrough_dropdown.splice(i,1);
	  	this.breakthrough.splice(this.breakthrough.length-1,1);

		setTimeout(() => {
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length == 1) {
				allBtDelIcon[0].classList.add('card-body__minus--hide');
			}
		},10)
  	}

  	public async BtOrderChange(event) {
		var that = this;
	  	var content = [];
	  	moveItemInArray(this.breakthrough_content, event.previousIndex, event.currentIndex);
	  	moveItemInArray(this.breakthrough_dropdown, event.previousIndex, event.currentIndex);
	  	for(var i=0; i<this.breakthrough_content.length;i++){
			content[i] = this.breakthrough_dropdown[i].concat("\n"+this.breakthrough_content[i]);
		}
	  	this.chService?.api.UpdateFramework({id:this.BtId,email:localStorage.getItem('email'), title:"vision", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(content)}).then(function (data){
			that.edit_breakthrough = false;
			that.breakthrough = JSON.parse(data.content);
			that.prev_breakthrough_content = JSON.parse(data.content);
	    	var breakthrough = JSON.parse(data.content);
	    	for(var i=0;i<breakthrough.length;i++){
	    		let data_str = (breakthrough[i]).split("\n");
	    		that.breakthrough_dropdown[i] = data_str[0];
	    		that.breakthrough_content[i] = data_str[1];
	    	}
	    	that.selected_breakthrough = that.breakthrough_dropdown[0]+that.breakthrough_content[0];
	  		setTimeout(() => {
	            toastr.options = {
	                closeButton: true,
	                progressBar: true,
	                timeOut: 2000
	            };
	            toastr.success('Your thoughts has been updated!', 'Nice!');
	        }, 1000);
		})
  	}

  	public DdStart(){
		this.DdId = '0';
		this.edit_datadump = true;
		this.datadump_content[0] = '';
    	this.data_dump[0] = '';
    	this.datadump_content[1] = '';
    	this.data_dump[1] = '';
		this.DdDiverge();
	}

  	public DdConverge(){
  		this.cancelDd();
		this.showDatadump = false;
		this.edit_datadump = false;
	}

	public DdDiverge(trackit=0,currentTrack=''){
		this.showDatadump = false;
		this.edit_datadump = true;
		this.cancelQt();
		this.cancelBt();

		if(trackit == 1){
			this.openEditmode(false,true,false);
			this.trackLabel = true;
			this.trackbtn = true;
			this.currentTracker = currentTrack;
			this.clarifyEyeIcon = true;
		}else{
			this.PreviousTracker = 'Data';
			this.openEditmode(false,true,false,true);
			this.clarifyEyeIcon = false;
		}
		setTimeout(() => {
			$(document).scrollTop(0);
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length == 1) {
				allBtDelIcon[0].classList.add('card-body__minus--hide');
			}
		}, 10);

	}

	public dupli_submitDatadump(backto = 0){
		for(let i =1; i < this.data_dump.length; i++){
			if(this.dupli_datadump_content[i] != this.datadump_content[i]){
				this.datadump_content.push(this.dupli_datadump_content[i]);
				if(this.datadump_content[0].length > 0 && this.trackbtn){
					this.datadump_content[0].push(this.dupli_datadump_content[i]);
				}
			}
		}
		if(backto){
			this.submitDatadump(false,true);
		}else{
			this.submitDatadump(false);
		}
	}

  	public async submitDatadump(click = true,callback=false){
		this.openEditmode(false,true,false,click);

  		for(var i=1;i<this.datadump_content.length;i++){
  			if(this.datadump_content[i] == null || this.datadump_content[i] == ''){
  				this.datadump_content.splice(i,1);
  				this.data_dump.splice(this.data_dump.length-1,1);
  			}
  		}
	  	if(this.datadump_content.length > 1){
	  		this.loading_datadump = true;
	  		var that = this;

	  		for(var j=0; j<this.datadump_content[0].length; j++){
	  			for(var k=1; k<this.datadump_content.length; k++){
	  				if(this.datadump_content[0][j] == this.datadump_content[k]){
	  					break;
	  				}
	  				if(k == this.datadump_content.length - 1 && this.datadump_content[0][j] != this.datadump_content[k]){
	  					this.datadump_content[0].splice(j,1);
	  				}
	  			}
	  		}

	  		if(!this.Ddupdate){
	  			await	this.chService?.api.CreateFramework({email:localStorage.getItem('email'), title:"data-gather", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(this.datadump_content)}).then(function (data){
						that.edit_datadump = false;
						that.DdId = data.id;
						that.Ddupdate = true;
						that.data_dump = JSON.parse(data.content);
						that.loading_datadump = false;
						that.datadump_content = JSON.parse(data.content);
						that.prev_datadump_content = JSON.parse(data.content);
						that.showDatadump = false;
						setTimeout(() => {
							toastr.options = {
								closeButton: true,
								progressBar: true,
								timeOut: 2000
							};
							toastr.success('Your thought has been updated!', 'Nice!');
						}, 1000);
					})
	  		}else{
	  			await	this.chService?.api.UpdateFramework({id:this.DdId,email:localStorage.getItem('email'), title:"data-gather", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(this.datadump_content)}).then(function (data){
						that.edit_datadump = false;
						that.loading_datadump = false;
						that.data_dump = JSON.parse(data.content);
						that.datadump_content = JSON.parse(data.content);
						that.prev_datadump_content = JSON.parse(data.content);
						that.showDatadump = false;
						setTimeout(() => {
							toastr.options = {
								closeButton: true,
								progressBar: true,
								timeOut: 2000
							};
							toastr.success('Your thoughts have been updated!', 'Nice!');
						}, 1000);
					})
	  		}
  		}else{
  			if(this.DdId && this.DdId != '0'){
	  			this.delDatadump();
	  		}
  			this.DdId = '';
	  		this.edit_datadump = false;
  		}
		if(callback){
			switch(this.PreviousTracker){
				case 'Data':
					this.DdDiverge();
					break;
				case 'Challenge':
					this.QtDiverge();
					break;
			}
		}
  	}

  	public delDatadump(){
	  	var that = this;
		this.trackLabel = false;
		this.dupli_datadump_content = [];
		try {
			this.chService.api.DeleteFramework({id:this.DdId}).then(function(){
				that.datadump_content = [];
				that.prev_datadump_content = [];
				that.data_dump = [];
				that.Ddupdate = false;
				that.edit_datadump = false;
				that.DdId = '';
				that.datadump_content[0] = '';
				that.data_dump[0] = '';
				that.datadump_content[1] = '';
				that.data_dump[1] = '';
				setTimeout(() => {
					toastr.options = {
						closeButton: true,
						progressBar: true,
						timeOut: 2000
					};
					toastr.success('Your thoughts has been deleted!', 'Nice!');
				}, 1000);
			})
		} catch (err) {
		}
  	}
  	public submit_converge_datadump(){
		if(this.pin_challenge){
			this.pin_challenge = this.editmodeService.stickChallenge(this.pin_challenge);
		}
  		this.edit_datadump = false;
  		this.showDatadump = true;
		this.trackLabel = false;
		this.trackbtn = false;
		this.openEditmode(true,true,true,true,'block','#fff');
  	}

  	public addDdLine(){
		if(this.trackbtn){
			this.trackbtn = false;
		}
		setTimeout(() => {
			$('.card-body__editcol.hideblk:last-child').css('display','block');
		},50);
  		if(document.activeElement.id){
		  	if(this.data_dump.length <= parseInt(document.activeElement.id.replace("Dd","")) + 1 ){
	  			this.data_dump.push(this.data_dump.length);
	  		}else{
	  			for(var i=parseInt(document.activeElement.id.replace("Dd",""))+1; i<=this.data_dump.length-1; i++){
	  				if(this.datadump_content[i] == '' || this.datadump_content[i] == undefined){
	  					document.getElementById("Dd"+ (i)).focus();
	  					break;
	  				}
	  				if(i == this.data_dump.length - 1 && this.datadump_content[i] != '' && this.datadump_content[i] != undefined){
	  					this.data_dump.push(this.data_dump.length);
	  				}
	  			}
	  		}
	  	}else{
	  		this.data_dump.push(this.data_dump.length);
	  	}

		setTimeout(() => {
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length > 1) {
				allBtDelIcon[0].classList.remove('card-body__minus--hide');
			}
		},10)
  	}

  	public subDdLine(i){
	  	this.datadump_content.splice(i,1);
	  	this.dupli_datadump_content.splice(i,1);
	  	this.data_dump.splice(this.data_dump.length-1,1);
		setTimeout(() => {
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length == 1) {
				allBtDelIcon[0].classList.add('card-body__minus--hide');
			}
		},10)
  	}

  	public async DdOrderChange(event) {
	  	var that = this;
	  	moveItemInArray(this.datadump_content[0], event.previousIndex, event.currentIndex);
	  	this.chService.api.UpdateFramework({id:this.DdId,email:localStorage.getItem('email'), title:"data-gather", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(this.datadump_content)}).then(function (data){
			that.edit_datadump = false;
			that.data_dump = JSON.parse(data.content);
	    	that.datadump_content = JSON.parse(data.content);
	    	that.prev_datadump_content = JSON.parse(data.content);
	    	that.selected_datadump = that.datadump_content[0];
	  		setTimeout(() => {
	            toastr.options = {
	                closeButton: true,
	                progressBar: true,
	                timeOut: 2000
	            };
	            toastr.success('Your thoughts has been updated!', 'Nice!');
	        }, 1000);
		})
  	}

  	public QtStart(trackit = 0){
		if(trackit == 1) {
			if(this.question_content[0] == '' || this.question_content[0] == undefined){
				this.QtId = '0';
			this.edit_question = true;
			this.question_content[0] = '';
			this.question_dropdown[0] = '';
			this.question[0] = '';
			this.question_content[1] = '';
			this.question_dropdown[1] = 'How might...';
			this.question[1] = '';
			this.QtDiverge();
			}else{
				this.QtDiverge(1);
			}
		}else {
			this.QtId = '0';
			this.edit_question = true;
			this.question_content[0] = '';
			this.question_dropdown[0] = '';
			this.question[0] = '';
			this.question_content[1] = '';
			this.question_dropdown[1] = 'How might...';
			this.question[1] = '';
			this.QtDiverge();
		}
		this.loader = false;
	}

  	public QtConverge(){
  		this.cancelQt();
		this.showQuestion = false;
		this.edit_question = false;
	}

	public QtDiverge(trackit = 0){
		this.showQuestion = false;
		this.edit_question = true;
		if(trackit == 1){
			this.openEditmode(false,false,true,true);
			this.trackbtn =true;
			this.trackLabel = true;
			this.PreviousTracker = 'Ideate';
			this.currentTracker = 'Challenge';
			this.loader = false;
			this.clarifyEyeIcon = true;
		}else{
			this.cancelDd();
			this.cancelBt();
			this.openEditmode(false,false,true,true);
			this.PreviousTracker = 'Challenge';
			this.clarifyEyeIcon = false;
		}
		setTimeout(() => {
			$(document).scrollTop(0);
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length == 1) {
				allBtDelIcon[0].classList.add('card-body__minus--hide');
			}
		}, 10);
	}

	public dupli_submitQuestion(backto = false) {
		if(this.question_content[0].length > 0 && this.trackLabel){
			for(let i =1; i < this.dupli_question_content.length; i++){
				if(this.dupli_question_content[i] != this.question_content[i] && this.question_content[i] != ''){
					this.addQtLine();
					this.question_content.push(this.dupli_question_content[i]);
					this.question_content[0] = this.dupli_question_content[i];
				}
			}
		}else {
			this.question_content = this.dupli_question_content;
		}
		if(backto){
			this.submitQuestion(false,true);
		}else{
			this.submitQuestion(false);
		}
	}

  	public submitQuestion(click = true,trackit = false){
		this.openEditmode(false,false,true,click);

  		var change_selected = 0;
  		for(var i=1; i<this.question_content.length;i++){
  			if(this.question_content[i] == this.question_content[0] && this.question_dropdown[i] == this.question_dropdown[0]){
  				change_selected = 1;
  			}
			if(this.question_content[i] == null || this.question_content[i] == ''){
				this.question_content.splice(i,1);
				this.question_dropdown.splice(i,1);
			}
			if(i == this.question_content.length - 1 && change_selected == 0){
  				this.question_content[0] = '';
  				this.question_dropdown[0] = '';
  			}
		}
	  	if(this.question_content.length > 1){
	  		this.loading_question = true;
	  		var that = this;
	  		var content = [];

	  		for(var i=0; i<this.question_content.length;i++){
	  			content[i] = this.question_dropdown[i].concat("\n"+this.question_content[i]);
	  		}
	  		if(!this.Qtupdate){
	  			this.chService?.api.CreateFramework({email:localStorage.getItem('email'), title:"breakthrough-question", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(content)}).then(function (data){
		  			that.edit_question = false;
		  			that.QtId = data.id;
		  			that.Qtupdate = true;
		  			that.loading_question = false;
		  			that.question = JSON.parse(data.content);
		  			that.prev_question_content = JSON.parse(data.content);
		        	var ques = JSON.parse(data.content);
		        	that.showQuestion = false;
		        	for(var i=0;i<ques.length;i++){
		        		let data_str = (ques[i]).split("\n");
		        		that.question_dropdown[i] = data_str[0];
		        		that.question_content[i] = data_str[1];
		        	}
		        	that.selected_question = that.question_dropdown[0]+that.question_content[0];
			  		setTimeout(() => {
			            toastr.options = {
			                closeButton: true,
			                progressBar: true,
			                timeOut: 2000
			            };
			            toastr.success('Your thought has been updated!', 'Nice!');
			        }, 1000);
		  		})
	  		}else{
	  			this.chService?.api.UpdateFramework({id:this.QtId,email:localStorage.getItem('email'), title:"breakthrough-question", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(content)}).then(function (data){
		  			that.edit_question = false;
		  			that.loading_question = false;
		  			that.question = JSON.parse(data.content);
		  			that.prev_question_content = JSON.parse(data.content);
		  			that.showQuestion = false;
		        	var ques = JSON.parse(data.content);
		        	for(var i=0;i<ques.length;i++){
		        		let data_str = (ques[i]).split("\n");
		        		that.question_dropdown[i] = data_str[0];
		        		that.question_content[i] = data_str[1];
		        	}
		  			that.selected_question = that.question_dropdown[0]+that.question_content[0];
			  		setTimeout(() => {
			            toastr.options = {
			                closeButton: true,
			                progressBar: true,
			                timeOut: 2000
			            };
			            toastr.success('Your thoughts have been updated!', 'Nice!');
			        }, 1000);
		  		})
	  		}

  		}else{
  			if(this.QtId && this.QtId != '0'){
	  			this.delQuestion();
	  		}
  			this.QtId = '';
	  		this.edit_question = false;
  		}
		if(trackit){
			switch(this.PreviousTracker){
				case 'Data':
					this.DdDiverge();
					break;
				case 'Challenge':
					this.QtDiverge();
					break;
				case 'Ideate':
					this.router.navigate(['/challenges/ideate'])
					break;
			}
		}
  	}

  	public submit_converge_question(){
		if(this.pin_challenge){
			this.pin_challenge = this.editmodeService.stickChallenge(this.pin_challenge);
		}
  		this.edit_question = false;
  		this.showQuestion = true;
		this.trackLabel = false;
		this.trackbtn = false;
		this.openEditmode(true,true,true,true,'block','#fff');
  	}

  	public delQuestion(){
	  	var that = this;
		this.dupli_question_content = [];
		try {
			this.chService.api.DeleteFramework({id:this.QtId}).then(function(){
				that.question_content = [];
				that.question_dropdown = [];
				that.question = [];
				that.prev_question_content = [];
				that.Qtupdate = false;
				that.QtId = '';
				that.edit_question = false;
				that.question_content[0] = '';
				that.question_dropdown[0] = '';
				that.question[0] = '';
				that.question_content[1] = '';
				that.question_dropdown[1] = 'How might...';
				that.question[1] = '';
				setTimeout(() => {
					toastr.options = {
						closeButton: true,
						progressBar: true,
						timeOut: 2000
					};
					toastr.success('Your thoughts has been deleted!', 'Nice!');
				}, 1000);
			})
		} catch (err) {
		}
  	}

  	public addQtLine(){
		if(this.trackbtn){
			this.trackbtn = false;
		}
		setTimeout(() => {
			$('.card-body__editcol.hideblk:last-child').css('display','block');
		},50);
  		if(document.activeElement.id){
	  		if(this.question.length <= parseInt(document.activeElement.id.replace("Qt","")) + 1 ){
	  			this.question.push(this.question.length);
	  			this.question_dropdown[this.question.length - 1] = 'How might...';
	  		}else{
	  			for(var i=parseInt(document.activeElement.id.replace("Qt",""))+1; i<=this.question.length-1; i++){
	  				if(this.question_content[i] == '' || this.question_content[i] == undefined){
	  					document.getElementById("Qt"+ (i)).focus();
	  					break;
	  				}
	  				if(i == this.question.length - 1 && this.question_content[i] != '' && this.question_content[i] != undefined){
	  					this.question.push(this.question.length);
	  					this.question_dropdown[this.question.length - 1] = 'How might...';
	  				}
	  			}
	  		}
	  	}else{
	  		this.question.push(this.question.length);
			this.question_dropdown[this.question.length - 1] = 'How might...';
	  	}
		setTimeout(() => {
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length > 1) {
				allBtDelIcon[0].classList.remove('card-body__minus--hide');
			}
		},10)
  	}

  	public subQtLine(i){
  		if(this.selected_question == this.question_dropdown[i]+this.question_content[i]){
  			this.selected_question = '';
  			this.question_dropdown[0] = '';
  			this.question_content[0] = '';
  		}
	  	this.question_content.splice(i,1);
	  	this.question_dropdown.splice(i,1);
	  	this.question.splice(this.question.length-1,1);
		setTimeout(() => {
			let allBtDelIcon = document.querySelectorAll('.card-body__minus');
			if(allBtDelIcon.length == 1) {
				allBtDelIcon[0].classList.add('card-body__minus--hide');
			}
		},10)
  	}

  	public async QtOrderChange(event) {
	  	var that = this;
	  	var content = [];
	  	moveItemInArray(this.question_content, event.previousIndex, event.currentIndex);
	  	moveItemInArray(this.question_dropdown, event.previousIndex, event.currentIndex);
	  	for(var i=0; i<this.question_content.length;i++){
			content[i] = this.question_dropdown[i].concat("\n"+this.question_content[i]);
		}
	  	this.chService.api.UpdateFramework({id:this.QtId,email:localStorage.getItem('email'), title:"breakthrough-question", processTypeId:"c1c17711-b4a3-4dcc-98b5-fe73ee0791d2",type:"process-stage", toolId:"3a8e48d7-110d-4a1e-9936-7438a518dd08", content:JSON.stringify(content)}).then(function (data){
			that.edit_question = false;
			that.question = JSON.parse(data.content);
			that.prev_question_content = JSON.parse(data.content);
	    	var ques = JSON.parse(data.content);
	    	for(var i=0;i<ques.length;i++){
	    		let data_str = (ques[i]).split("\n");
	    		that.question_dropdown[i] = data_str[0];
	    		that.question_content[i] = data_str[1];
	    	}
	    	that.selected_question = that.question_dropdown[0]+that.question_content[0];
	  		setTimeout(() => {
	            toastr.options = {
	                closeButton: true,
	                progressBar: true,
	                timeOut: 2000
	            };
	            toastr.success('Your thoughts has been updated!', 'Nice!');
	        }, 1000);
		})
  	}

  	public checkBreakthrough(content1, content2){
	  	this.selected_breakthrough = content1+content2;
	  	this.breakthrough_dropdown[0] = content1;
	  	this.breakthrough_content[0] = content2;
  		this.submitBreakthrough(false);
  	}

  	public checkDataDump(){
  		var that = this;
  		this.datadump_content[0] = [];
  		$(".checkedbox-dumpData:checkbox").each(function(i) {
	        var value = $(this).val();
	        if($(this).prop('checked') == true){
	  			that.datadump_content[0].push(value);
	  		}
			})
  		this.submitDatadump(false);
  	}

  	public checkQuestion(content1, content2, i){
  		if(content2.indexOf('?') > -1){
		  	this.selected_question = content1+content2;
		  	this.question_dropdown[0] = content1;
		  	this.question_content[0] = content2;
	  		this.submitQuestion();
	  	}else{
			Swal.fire({
				  title: "Do you want to add a question mark to the end of this challenge?",
				  icon: "question",
					showCancelButton: true,
				  confirmButtonText: "Yes",
				  cancelButtonText: "No"
			  }).then((result) => {
				  if (result['value'] == true) {
					content2 = content2 + '?';
					this.selected_question = content1+content2;
					this.question_dropdown[0] = content1;
					this.question_content[0] = content2;
					this.question_content[i] = this.question_content[i] + '?';
					this.submitQuestion();
					$('.swal2-container').addClass('hide');
					$('body').removeClass('swal2-shown');
					$('html').removeClass('swal2-shown');
				  }else{
					this.selected_question = content1+content2;
					this.question_dropdown[0] = content1;
					this.question_content[0] = content2;
					this.submitQuestion();
					$('.swal2-container').addClass('hide');
					$('body').removeClass('swal2-shown');
					$('html').removeClass('swal2-shown');
				  }
			  },function(dismiss){
				  $('.swal2-container').addClass('hide');
				  $('body').removeClass('swal2-shown');
				  $('html').removeClass('swal2-shown');
			  });
	  	}
  	}

  	public cancelBt(){
		this.editmodeService.tooltipPopup.next({
			process_type: '',
			popup_type: '',
			showVideo: false,
			DivergeConvergeVal: false,
			hideOnEditMode: true
		});
		this.pin_challenge = this.editmodeService.stickChallenge(true);
		this.openEditmode(true,true,true,true,'block','#fff');
		this.trackLabel = false;
		this.trackbtn = false;

    	this.edit_breakthrough = false;
  		var breakthrough = this.prev_breakthrough_content;
  		this.breakthrough_dropdown = [];
  		this.breakthrough_content = [];
  		this.breakthrough = [];
    	for(var i=0;i<breakthrough.length;i++){
    		let data_str = (breakthrough[i]).split("\n");
    		this.breakthrough_dropdown[i] = data_str[0];
    		this.breakthrough_content[i] = data_str[1];
    		this.breakthrough[i] = i;
    	}
    	this.selected_breakthrough = this.breakthrough_dropdown[0]+this.breakthrough_content[0];
    	if(this.BtId == '0'){
    		this.edit_breakthrough = false;
    		this.BtId = '';
    		this.breakthrough_content[0] = '';
        	this.breakthrough_dropdown[0] = '';
        	this.breakthrough[0] = '';
        	this.breakthrough_content[1] = '';
        	this.breakthrough_dropdown[1] = 'It would be great if...';
        	this.breakthrough[1] = '';
    	}

    	if(this.BtId != '' && this.BtId != '0'){
    		this.showBreakthrough = true;
    	}
  	}

  	public cancelDd(){
		this.editmodeService.tooltipPopup.next({
			process_type: '',
			popup_type: '',
			showVideo: false,
			DivergeConvergeVal: false,
			hideOnEditMode: true
		});
		if(this.pin_challenge){
			this.pin_challenge = this.editmodeService.stickChallenge(this.pin_challenge);
		}
		this.openEditmode(true,true,true,true,'block','#fff');
		this.trackLabel = false;
		this.trackbtn = false;

  		this.edit_datadump = false;
  		var data_dump = this.prev_datadump_content;
  		this.datadump_content = [];
  		this.data_dump = [];
  		for(var i=0;i<data_dump.length;i++){
    		let data_str = data_dump[i];
    		this.datadump_content[i] = data_str;
    		this.data_dump[i] = i;
    	}
    	if(this.DdId == '0'){
    		this.edit_datadump = false;
    		this.DdId = '';
    		this.datadump_content[0] = '';
        	this.data_dump[0] = '';
        	this.datadump_content[1] = '';
        	this.data_dump[1] = '';
    	}
    	if(this.DdId != '' && this.DdId != '0'){
    		this.showDatadump = true;
    	}
  	}

  	public cancelQt(){
		this.editmodeService.tooltipPopup.next({
			process_type: '',
			popup_type: '',
			showVideo: false,
			DivergeConvergeVal: false,
			hideOnEditMode: true
		});
		if(this.pin_challenge){
			this.pin_challenge = this.editmodeService.stickChallenge(this.pin_challenge);
		}
		this.openEditmode(true,true,true,true,'block','#fff');
		this.trackLabel = false;
		this.trackbtn = false;

  		this.edit_question = false;
  		var ques = this.prev_question_content;
  		this.question_content = [];
  		this.question_dropdown = [];
  		this.question = [];
    	for(var i=0;i<ques.length;i++){
    		let data_str = (ques[i]).split("\n");
    		this.question_dropdown[i] = data_str[0];
    		this.question_content[i] = data_str[1];
    		this.question[i] = i;
    	}
    	this.selected_question = this.question_dropdown[0]+this.question_content[0];
    	if(this.QtId == '0'){
    		this.edit_question = false;
    		this.QtId = '';
    		this.question_content[0] = '';
        	this.question_dropdown[0] = '';
        	this.question[0] = '';
        	this.question_content[1] = '';
        	this.question_dropdown[1] = 'How might...';
        	this.question[1] = '';
    	}

    	if(this.QtId != '' && this.QtId != '0'){
    		this.showQuestion = true;
    	}
  	}

  	public openPopup(content,showDivCon=0){
		this.editmodeService.tooltipPopup.next({
			process_type: content,
			popup_type: 'info',
			showVideo: false,
			DivergeConvergeVal: false,
			hideOnEditMode: true
		});
  	}

	public async DataModel(value){
		$('.cn-dmodal').css('display', 'block');
		this.deleteDatavalue = value;
		this.allChallenge.delData.pipe(
			take(1),
			takeUntil(this.destroy$)
		).subscribe((data)=> {
			if(data) {
				this.deletedata();
				this.allChallenge.delData.next(false)
			}
		})
	  }

	public deletedata(){
		$('.cn-dmodal').css('display', 'none');
		this.trackLabel =false;
		this.openEditmode(true,true,true,true,'block','#fff')
		switch(this.deleteDatavalue){
			case 1:
				this.delBreakthrough();
				break;
			case 2:
				this.delDatadump();
				break;
			case 3:
				this.delQuestion();
				break;
			default:
				break;
		}
	}

	public openEditmode(editgoal,editdata,editchall,sidenav=false,displaynone='none',bgcolor="#EBEBEB"){
		this.editGoalView = editgoal;
		this.editDataView = editdata;
		this.editChallengeView = editchall;
		let page = document.getElementById('page-wrapper');
		page.style.backgroundColor = bgcolor;
		let footer = document.querySelector('.footer') as HTMLElement;
		footer.style.backgroundColor = bgcolor;
		footer.style.border = '1px solid #CFDBE2'
		if(editgoal && !editdata && !editchall){
			this.goalInput = false;
			this.dataInput = false;
			this.EditModeIcon = true;
			this.editmodeService.editmode.next(true);
			this.hideOnEditMode = false;
		}else if(editdata  && !editgoal && !editchall){
			this.goalInput = true;
			this.dataInput = false;
			this.EditModeIcon = true;
			this.editmodeService.editmode.next(true);
			this.hideOnEditMode = false;
		}else if(editchall && !editgoal && !editdata){
			this.goalInput = true;
			this.dataInput = true;
			this.EditModeIcon = true;
			this.editmodeService.editmode.next(true)
			this.hideOnEditMode = false;
		}else{
		this.hideOnEditMode = true;
		this.pin_challenge = false;
		this.listGridView = 'listView';
		this.hideOnEditMode = true;
		this.EditModeIcon = false;
		this.editGoalView = true;
		this.editDataView = true;
		this.editChallengeView = true;
		this.goalInput = false;
		this.dataInput = false;
		this.editmodeService.editmode.next(false);
		this.editmodeService.tooltipPopup.next({
			process_type: '',
			popup_type: '',
			showVideo: false,
			DivergeConvergeVal: false,
			hideOnEditMode: this.hideOnEditMode
		})
		}
	}

	public activeIcon(viewtype){
		this.listGridView = viewtype;
		if(this.listGridView == 'gridView'){
			let items = document.querySelectorAll('.editmode__listcol');
			this.gridViewClass = 'editmode__listrow--grid' + items.length;
		}
	}

	public eyesHideDiverge(){
		if(this.hideclarify){
			$('.card-body__editcol.hideblk').css('display','block');
			$('.card-body__subtitle span').css('opacity','1');
			this.hideclarify = false;
			this.hideDivLabel = 'Hide unconverged options';
		}else{
			$('.card-body__editcol.hideblk').css('display','none');
			$('.card-body__subtitle span').css('opacity','0.7');
			this.hideclarify = true;
			this.hideDivLabel = 'See all diverged options';
		}
	}

	public notingTodo(){
	}

	public openAi() {
		this.openAiData = [];
		this.selectAiData = [];
		var that = this;
		var all_data:any = ['Identify the root cause of the problem','Develop a range of potential solutions','Select the most effective solution','Implement the chosen solution','Monitor and evaluate the results','Lack of clear plan','Lack of accountability','Setting unrealistic goals','Lack of motivation','Distractions','Lack of focus','Lack of persistence','Lack of clarity','Fear of failure or success','Self-doubt or negative self-talk'];
		$('.popaccordian__gen__aidata').css('display', 'block');
		this.temprature = +this.temprature;
		let data = {
			prompt:`using ${this.statementStarter} Generate 5 goals for creative problem solving as ${this.personae}`,
			max_tokens:128,
			temperature: this.temprature,
		}
		this.http.post(`${environment.assessment_admin}api/v1/open_ai/completions.json`,data).subscribe({
			next: (res) => {
				for (let i = 0; i < res['choices'][0]?.text.length; i++) {
					this.openAiData = res['choices'][0]?.text.split('\n')
				}
			},
			error: (err) => {
				setTimeout(() => {
					toastr.options = {
						closeButton: true,
						progressBar: true,
						timeOut: 2000
					};
					toastr.error("Something went wrong!", "Sorry!");
				}, 1000);
			}
		});
	}

	public selectedData() {
		for (let i = 0; i < this.openAiData.length; i++) {
			if(this.selectAiData[i]) {
				this.addBtLine();
				this.selectAiData[i] = false;
				this.dupli_breakthrough_content.push(this.openAiData[i]);
			}
		}
	}

}
